import _ from "lodash";
import React, { useState } from "react";
import { Modal, TextInput, Button } from "@toddle-edu/ds-web";

import classes from "./CreateConversation.scss";

import { useI18n } from "Hooks";

const styles = {};

const CreateConversation = props => {
  const {
    onModalClose,
    onCreateConversation,
    isRenameMode,
    onRenameConversation,
    actionConversationDetails,
  } = props;
  const existingLabel = _.get(actionConversationDetails, "metadata.label", "");
  const [value, setValue] = useState(isRenameMode ? existingLabel : "");
  const { t } = useI18n(["common"]);

  const onSaveButtonClick = () => {
    if (isRenameMode) {
      onRenameConversation({ label: value });
    } else {
      onCreateConversation({ label: value });
    }
    onModalClose();
  };

  return (
    <Modal width="528px" height="max-content" onClose={onModalClose}>
      <Modal.Header title={isRenameMode ? t("common:rename") : "Title"} />
      <Modal.Body>
        <TextInput
          value={value}
          size={"large"}
          placeholder={"Enter title"}
          onChange={e => setValue(e.target.value)}
          style={styles.textInput}
        />
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.footerContainer}>
          <Button size="large" variant="outlined-subtle" onClick={onModalClose}>
            {t("common:cancel")}
          </Button>
          <Button
            size="large"
            variant="progressive"
            onClick={onSaveButtonClick}
            disabled={!value}
          >
            {isRenameMode ? t("common:rename") : t("common:create")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateConversation;
